<div style="width: 448px; min-height: 500px; margin: 0 auto">
  <div
    class="dom-container"
    role="main"
  >
    <div id="dom-overlay"></div>
    <div id="dom-widget"></div>
    <div
      id="dom-sronly"
      aria-live="assertive"
    ></div>
  </div>
</div>
